export const replaceLinksWithTags = (message: string) => {
  const regex = /https:\/\/\S+/g
  return message.replace(regex, '<a href="$&" style="text-decoration: underline" target="_blank">$&</a>')
}

export const getBorderStyle = (startsSequence?: boolean, endsSequence?: boolean) => {
  const position = ['message', `${startsSequence ? 'start' : ''}`, `${endsSequence ? 'end' : ''}`].join(' ').trim()
  let borderStyle
  if (position === 'message start end') {
    borderStyle = 'tw-rounded-3xl'
  }

  if (position === 'message start') {
    borderStyle = 'tw-rounded-tl-3xl tw-rounded-br-3xl tw-rounded-tr-3xl tw-rounded-bl-md'
  }

  if (position === 'message  end') {
    borderStyle = 'tw-rounded-tl-md tw-rounded-br-3xl tw-rounded-tr-3xl tw-rounded-bl-3xl'
  }
  if (position === 'message') {
    borderStyle = 'tw-rounded-tl-md tw-rounded-bl-md tw-rounded-br-3xl tw-rounded-tr-3xl'
  }

  return borderStyle
}
